import { render, staticRenderFns } from "./Siteadmin.vue?vue&type=template&id=86dfa9c8&scoped=true&"
import script from "./Siteadmin.vue?vue&type=script&lang=js&"
export * from "./Siteadmin.vue?vue&type=script&lang=js&"
import style0 from "./Siteadmin.vue?vue&type=style&index=0&id=86dfa9c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dfa9c8",
  null
  
)

export default component.exports